import { render, staticRenderFns } from "./GalleryList.vue?vue&type=template&id=639681be&scoped=true&lang=pug&"
import script from "./GalleryList.vue?vue&type=script&lang=js&"
export * from "./GalleryList.vue?vue&type=script&lang=js&"
import style0 from "./GalleryList.vue?vue&type=style&index=0&id=639681be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639681be",
  null
  
)

export default component.exports